import React from 'react'
import PropTypes from "prop-types";

const styles = theme => ({
    root: { position: "relative" },
    wrapper: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        "& > *": { height: "100%", width: "100%" }
    }
})

const AspectRatioBox = ({ children, ratio = 1 }) => {
    const classes = styles();
    return (
        <div className={classes.root}>
            <div className={classes.wrapper}>{children}</div>
            <div style={{ paddingBottom: (1 / ratio) * 100 + "%" }} />
        </div>
    );
};

AspectRatioBox.propTypes = {
    ratio: PropTypes.number,
}

export default AspectRatioBox;